import type { ETab } from '../reducers/location'
import type { Type_ILocation } from '../../../zap/Type/Type.hive'

export const location_SELECT_TAB = 'location_SELECT_TAB'
export const location_SET_MAP_LOCATIONS = 'location_MAP_LOCATIONS'

export type TLocationAction =
    | { type: 'location_SELECT_TAB'; tab: ETab }
    | {
          type: typeof location_SET_MAP_LOCATIONS
          locations: Type_ILocation[]
      }

export const selectTab = (tab: ETab): TLocationAction => ({
    type: location_SELECT_TAB,
    tab,
})

export const setMapLocations = (locations: Type_ILocation[]): TLocationAction => ({
    type: location_SET_MAP_LOCATIONS,
    locations,
})
